import { useTranslation } from 'react-i18next'
import './AuthenticationError.scss'

type AuthenticationErrorProps = {
    state?: {
        errorCode?: string
    } | null
}

const AuthenticationError = ({ state }: AuthenticationErrorProps) => {
    const { t } = useTranslation()
    console.warn(t('authenticationError:authenticationError'), state)

    return (
        <div className="authentication-error">
            <p>
                <strong>{t('authenticationError:authenticationError')}</strong>
                {state?.errorCode}
            </p>
        </div>
    )
}
export default AuthenticationError
